const TableBody = ({ children }) => {
  return <tbody className="relative w-full divide-y divide-gray-200 overflow-y-auto">{children}</tbody>;
};

export default TableBody;
